<template>
  <span>{{ address }}</span>
</template>

<script>
import {decodeEmail} from '@/util/emailObfuscate';

export default {
  name: 'ObfuscatedEmail',
  props: {
    emailKey: {
      type: String,
      required: true,
    },
  },
  computed: {
    address() {
      return decodeEmail(this.emailKey);
    },
  },
};
</script>
